export const EMAIL = {
    LABEL: 'Email',
    PLACEHOLDER: 'e.g. alex@example.com',
    TYPE: 'email',
} as const;


export const FIRSTNAME = {
    LABEL: 'Firstname',
    PLACEHOLDER: 'e.g. John',
    TYPE: 'text',
} as const;

export const LASTNAME = {
    LABEL: 'Lastname',
    PLACEHOLDER: 'e.g. Doe',
    TYPE: 'text',
} as const;

export const PASSWORD = {
    LABEL: 'Password',
    PLACEHOLDER: '********',
    TYPE: 'password',
} as const;

export const CHANNEL_PARTNER = {
    LABEL: 'Channel Partner'
} as const;

export const ROLE = {
    LABEL: 'Role'
} as const;
